import { CustomVariablesReducer, CustomVariablesAction, READ_CUSTOM_VARIABLES_FULFILLED } from './types';
const initialState = {
	customeVariables: [],
};
export const customVariableReducer: CustomVariablesReducer = (state = initialState, action: CustomVariablesAction) => {
	switch (action.type) {
		case READ_CUSTOM_VARIABLES_FULFILLED:
			return {
				...state,
				customeVariables: action.payload,
			};
		default:
			return state;
	}
};
